import Nav from "./Nav";
import "./Project.css";
import "../App.css";
import React, { useState } from "react";
import pageTransition from "../transition";
import data from "./data/research.json";

const Research = () => {
  document.title = "Xinyi | Research";
  const [projectID, setProject] = useState(0);

  function switchRight() {
    setProject((projectID + 1) % data.length);
  }

  function switchLeft() {
    setProject((projectID - 1 + data.length) % data.length);
  }


  document.addEventListener("keydown", (event) => {
    if (event.key === 'ArrowRight') {
      switchRight();
    }
    if (event.key === 'ArrowLeft') {
      switchLeft();
    }
  })

  return (
    <>
      {Nav("research", data[projectID].color)}

      <div className="project" id="research">
        <div className="img">
          {data[projectID].video ? (
            // play video if avaible
            <video 
              src={data[projectID].video} 
              className="project" 
              autoPlay 
              loop 
              muted 
              playsInline
            >
              Your browser does not support the video tag.
            </video>
          ) : (
            // image
            <img 
              src={data[projectID].image} 
              alt={data[projectID].alt} 
              className="project" 
              id={data[projectID].id}
            />
          )}
        </div>
        <div className="research-description">
          <h1>{data[projectID].title}</h1>

          <p className="description">{data[projectID].description}</p>

          {/* <a className="button" href={data[projectID].code}>
            <button>Download Code</button>
          </a> */}
        </div>
      </div>

      <div className="switch-container">
        <div className="switch-button" onClick={switchLeft} id="left">
          <p className="icon">&lt;</p>
        </div>
        <div className="switch-button" onClick={switchRight} id="right">
          <p className="icon">&gt;</p>
        </div>
      </div>
    </>
  );
};

export default pageTransition(Research);
